'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { IconStarHalf } from '../../svg/icons/icon-star-half.js';
import { IconStar } from '../../svg/icons/icon-star.js';
import { formatRate } from '../../util/formatters/format-rate.js';
import { Popover } from '../popover/popover.js';
import { ReviewDimension } from './dimension.js';

var RatingSize;
(function (RatingSize) {
    RatingSize["XS"] = "xs";
    RatingSize["SMALL"] = "small";
    RatingSize["MEDIUM"] = "medium";
    RatingSize["LARGE"] = "large";
})(RatingSize || (RatingSize = {}));
var RatingTextColor;
(function (RatingTextColor) {
    RatingTextColor["LIGHT"] = "light";
    RatingTextColor["DARK"] = "dark";
})(RatingTextColor || (RatingTextColor = {}));
const ratingSizeClasses = {
    [RatingSize.XS]: 'h-4 w-4',
    [RatingSize.SMALL]: 'h-4 w-4',
    [RatingSize.MEDIUM]: 'h-5 w-5',
    [RatingSize.LARGE]: 'h-8 w-8',
};
const ratingTextSizeClasses = {
    [RatingSize.XS]: 'text-sm',
    [RatingSize.SMALL]: 'text-base',
    [RatingSize.MEDIUM]: 'text-lg',
    [RatingSize.LARGE]: 'text-xl',
};
const ratingTextColorClasses = {
    [RatingTextColor.LIGHT]: 'text-leland-gray-light',
    [RatingTextColor.DARK]: 'text-leland-gray-dark',
};
const Rating = ({ rate, overallRate = rate, dimensionRates, hoverable, totalStars = 5, onSaveRating, showRate, size = hoverable ? RatingSize.LARGE : RatingSize.MEDIUM, textColor = RatingTextColor.LIGHT, }) => {
    const [hoverRate, setHoverRate] = useState(0);
    const formattedRate = formatRate(overallRate ?? 0);
    const hasDimensionRates = !!(dimensionRates?.knowledge ??
        dimensionRates?.value ??
        dimensionRates?.responsiveness ??
        dimensionRates?.supportiveness);
    const rateToUse = hoverRate || overallRate;
    return (jsxs("div", { className: "flex items-center justify-start", children: [jsx("div", { className: "flex", children: jsx("div", { className: "flex", children: Array.from({ length: totalStars }, (_, i) => i + 1).map((index) => {
                        const indexDifference = rateToUse - index;
                        return (jsx("button", { type: "button", onMouseEnter: () => setHoverRate(index), onMouseLeave: () => setHoverRate(0), onClick: () => onSaveRating?.(index), disabled: !hoverable, children: index <= rateToUse ||
                                indexDifference > -0.25 ||
                                (hoverRate === index && indexDifference > -0.75) ? (jsx(IconStar, { className: `${ratingSizeClasses[size]} ${hoverRate === index
                                    ? 'text-leland-yellow-hover active:text-leland-yellow-hover/80'
                                    : 'text-leland-yellow'}` })) : indexDifference > -0.75 ? (jsx(IconStarHalf, { className: `${ratingSizeClasses[size]} fill-leland-gray-stroke text-leland-yellow` })) : (jsx(IconStar, { className: `${ratingSizeClasses[size]} ${hoverRate === index
                                    ? 'text-leland-yellow active:text-leland-yellow-hover'
                                    : 'text-leland-gray-stroke'}` })) }, index));
                    }) }) }), showRate ? (hasDimensionRates && dimensionRates ? (jsx("div", { className: "relative", children: jsx(Popover, { asChild: true, disableAutoFocus: true, content: jsxs("div", { className: "flex flex-col space-y-4", children: [jsx(ReviewDimension, { rate: rate, dimension: "Overall Rating" }), jsx("hr", {}), jsx(ReviewDimension, { rate: dimensionRates.knowledge, dimension: "Knowledge" }), jsx(ReviewDimension, { rate: dimensionRates.value, dimension: "Value" }), jsx(ReviewDimension, { rate: dimensionRates.responsiveness, dimension: "Responsiveness" }), jsx(ReviewDimension, { rate: dimensionRates.supportiveness, dimension: "Supportiveness" })] }), side: "bottom", darkMode: false, children: jsx("p", { className: `ml-2 underline underline-offset-2 ${ratingTextSizeClasses[size]} ${ratingTextColorClasses[textColor]}`, children: formattedRate }) }) })) : (jsx("p", { className: `ml-2 ${ratingTextSizeClasses[size]} ${ratingTextColorClasses[textColor]}`, children: formattedRate }))) : null] }));
};

export { Rating, RatingSize, RatingTextColor };
//# sourceMappingURL=rating.js.map
